var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.52667 5.18667V11.6733C1.52667 12.94 2.42667 13.46 3.52 12.8333L5.08667 11.94C5.42667 11.7467 5.99333 11.7267 6.34667 11.9067L9.84667 13.66C10.2 13.8333 10.7667 13.82 11.1067 13.6267L13.9933 11.9733C14.36 11.76 14.6667 11.24 14.6667 10.8133V4.32667C14.6667 3.06 13.7667 2.54 12.6733 3.16667L11.1067 4.06C10.7667 4.25333 10.2 4.27333 9.84667 4.09333L6.34667 2.34667C5.99333 2.17333 5.42667 2.18667 5.08667 2.38L2.2 4.03333C1.82667 4.24667 1.52667 4.76667 1.52667 5.18667Z",
    stroke: "#1E5AD2",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.70667 2.66667V11.3333",
    stroke: "#1E5AD2",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.4867 4.41333V13.3333",
    stroke: "#1E5AD2",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0,
    d: "M0.650391 15.3496L0.650391 0.650391L15.3496 0.650391L15.3496 15.3496L0.650391 15.3496Z",
    stroke: "#1E5AD2",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBlue);
export default __webpack_public_path__ + "static/media/map-blue.d4883b9f4e040a811f487388a7dd2a21.svg";
export { ForwardRef as ReactComponent };